module.exports = __webpack_public_path__ + "5b5ca799686ba62161519464f9a32ea2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-1.png
// module id = 2853
// module chunks = 0